var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkbreak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4468_1996)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.827 1.51943C12.8479 0.533448 14.2151 -0.0121279 15.6343 0.000204616C17.0535 0.0125371 18.4111 0.581791 19.4147 1.58536C20.4182 2.58893 20.9875 3.94652 20.9998 5.36572C21.0121 6.78493 20.4666 8.15221 19.4806 9.17307L19.4696 9.18425L16.5 12.1343C16.5 12.1343 15.8257 11.4605 15.224 10.8588L18.188 7.9143C18.842 7.2343 19.2038 6.32507 19.1956 5.3814C19.1874 4.43526 18.8079 3.53021 18.1389 2.86116C17.4698 2.19211 16.5648 1.81261 15.6187 1.80439C14.6746 1.79619 13.765 2.1583 13.0849 2.81292L11.5381 4.35071C11.1848 4.70198 10.6136 4.70031 10.2624 4.34699C9.9111 3.99366 9.91276 3.42247 10.2661 3.07119L11.8177 1.52856L11.827 1.51943Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.81434 16.1855C4.15973 16.8569 3.79764 17.7547 3.80585 18.6865C3.81408 19.6207 4.19389 20.5143 4.86347 21.1749C5.53306 21.8355 6.43885 22.2102 7.38575 22.2184C8.33018 22.2265 9.24014 21.8692 9.92069 21.2234L11.4587 19.706C11.8113 19.3581 12.383 19.3581 12.7356 19.706C13.0881 20.0538 13.0881 20.6178 12.7356 20.9657L11.1917 22.4889L11.1805 22.4997C10.1588 23.4733 8.79042 24.012 7.37006 23.9998C5.94971 23.9876 4.59102 23.4255 3.58664 22.4346C2.58226 21.4437 2.01255 20.1032 2.0002 18.7019C1.98786 17.3006 2.53388 15.9506 3.52065 14.9426L3.53165 14.9316C3.53165 14.9316 6.48043 12.0435 7.53815 11L8.81521 12.2595L4.81434 16.1855Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L23.7071 22.2929C24.0976 22.6834 24.0976 23.3166 23.7071 23.7071C23.3166 24.0976 22.6834 24.0976 22.2929 23.7071L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4468_1996"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "current"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkbreak);
export default __webpack_public_path__ + "static/media/linkbreak.ed5df6597cc92c97b48f4b87309c3235.svg";
export { ForwardRef as ReactComponent };